// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3s3k3","footer":"Form_footer__2oTxd"};